import { log, LogLevel } from "logging/datadogBrowserLogs";
import { AlternativeTransportItineraryStop } from "shared/types/alternativeTransport";

export const sliceList = ({
  list,
  fromStopId,
  toStopId,
}: {
  list: AlternativeTransportItineraryStop[];
  fromStopId?: string;
  toStopId?: string;
}) => {
  const matchingStartIndex = fromStopId
    ? list.findIndex((stop) =>
        Object.values(stop.stopReference).includes(fromStopId),
      )
    : 0;
  const matchingEndIndex = toStopId
    ? list.findIndex((stop) =>
        Object.values(stop.stopReference).includes(toStopId),
      )
    : list.length - 1;
  if (matchingStartIndex === -1 || matchingEndIndex === -1) {
    log(
      LogLevel.error,
      "vehicleCancellation",
      "Could not find matching stop id",
    );
    return []; // Throws an error
  }
  return list.slice(matchingStartIndex, matchingEndIndex + 1);
};
